import { BsModalService } from 'ngx-bootstrap/modal';
import * as i0 from "@angular/core";
import * as i1 from "ngx-bootstrap/modal";
export class ModalsService {
    constructor(modalService) {
        this.modalService = modalService;
        this.config = {
            backdrop: false,
            ignoreBackdropClick: true
        };
    }
    openModal(component, options) {
        const config = Object.assign({}, this.config, options);
        this.modalRef = this.modalService.show(component, config);
    }
    closeModal() {
        this.modalRef.hide();
    }
}
ModalsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ModalsService_Factory() { return new ModalsService(i0.ɵɵinject(i1.BsModalService)); }, token: ModalsService, providedIn: "root" });
